
import gsap from 'gsap';

export const init404Anim = (container = document) => {
    // On cherche spécifiquement dans le nouveau container injecté par Barba
    const title = container.querySelector('.text-404');
    
    if (title && !title.classList.contains('is-animated')) {
        title.classList.add('is-animated');

        title.innerHTML = title.textContent
            .trim()
            .split("")
            .map(char => `<span class="inline-block">${char === " " ? "&nbsp;" : char}</span>`)
            .join("");

        gsap.set(title, { opacity: 1 });

        gsap.from(title.children, {
            y: -500,
            opacity: 0,
            rotation: 15,
            duration: 0.9,
            stagger: 0.1,
            ease: "bounce.out",
            delay: 0.6 // On augmente un poil pour être sûr que la transition Barba est finie
        });
    }
};